import { ref, get, query, orderByChild, equalTo } from "firebase/database";
import { PaymentData } from "../../models/payment";
import { db } from "../firebaseConfig";

export const getPaymentsByInvoiceNumber = async (
	invoiceNumber: string
): Promise<PaymentData[]> => {
	const paymentsRef = ref(db, "payments");
	const paymentsQuery = query(
		paymentsRef,
		orderByChild("invoiceNumber"),
		equalTo(invoiceNumber)
	);
	const snapshot = await get(paymentsQuery);
	const payments: PaymentData[] = [];

	if (snapshot.exists()) {
		snapshot.forEach((child) => {
			const val = child.val();
			// defensive check: ensure the stored object actually has the invoiceNumber we queried
			if (
				val &&
				(val.invoiceNumber === invoiceNumber ||
					String(val.invoiceNumber) === invoiceNumber)
			) {
				payments.push(val as PaymentData);
			}
		});
	}

	return payments;
};
